import React from "react";
import "./TableDescription.css";

const tableDescription = (props) => {
  return (
    <dl className="spec-list">
      {props.spec.map((data, idx) => (
        <div className="spec-row" key={idx}>
          <dt>{data.name}</dt>
          <dd>{data.value}</dd>
        </div>
      ))}
    </dl>
  );
};

export default tableDescription;
